import React from 'react';
import { useIntl } from 'react-intl';

import { TeacherReserveWidgetInactive } from '@edu-frontend/modules/src/widgets/teacherReserveCarousels';
import { ThemeProvider } from '@edu-frontend/modules/src/shared/lib/ThemeProvider';
import { hrLight } from '@edu-frontend/modules/src/components/ui/Theme';

import { WidgetWrapper } from '../../widgets.widget-wrapper/widget-wrapper';

export const TeacherReserveInactive = () => {
    const intl = useIntl();

    return (
        <WidgetWrapper background="#F4F5F6" fullWidth={true}>
            <ThemeProvider isRoot={false} theme={hrLight}>
                <TeacherReserveWidgetInactive
                    description={intl.formatMessage({ id: 'teacherReserve.inactive.description' })}
                    title={intl.formatMessage({ id: 'teacherReserve.inactive.title' })}
                />
            </ThemeProvider>
        </WidgetWrapper>
    );
};
